import React from 'react'

import styled from 'styled-components'

import { Link } from 'react-router-dom'

const Wrap = styled.div`
  & > * {
    display: inline-block;
    // margin: ${props => props.margin ? props.margin : '1.5rem'};
  }
`

const StyledLink = styled(Link)`
  height: 3rem;
  width: 100%;
  max-width: ${props => props.isFullWidth === 'true' ? '100%' : '280px'};
  line-height: 1.5rem;

  padding-top: 0.4375rem;
  padding-bottom: 0.5rem;
  padding-left: 32px;
  padding-right: 32px;

  text-align: center;
  text-transform: uppercase;
  text-decoration: none;
  font-weight: bold;
  font-size: 1rem;
  font-weight: bold;

  font-family: 'Source Sans Pro';

  color: ${props => props.variation === 'gold' ? '#232323' : '#fff'};
  background: ${props => props.variation === 'transparent' ? 'rgba(0, 0, 0, 0.3)' : props.variation === 'gold' ? '#F2C94C' : '#000'};
  box-sizing: border-box;
  border: 2px solid ${props => props.variation === 'gold' ? '#F2C94C' : '#fff'};
  user-select: none;

  transition: color 150ms ease-in-out, background-color 150ms ease-in-out;

  &:hover {
    color: #000;
    background: #fff;
  }
  &:focus
  {
    outline: none;
  }

`

export const StyledButtonLink = styled(Link) `
  height: 3rem;
  width: 100%;
  max-width: ${props => props.isFullWidth === 'true' ? '100%' : '280px'};

  vertical-align: top;
  font-family: 'Source Sans Pro';
  line-height: 1.5rem;

  padding-top: 0.4375rem;
  padding-bottom: 0.5rem;
  padding-left: 32px;
  padding-right: 32px;
  display: inline-block;

  text-align: center;
  text-transform: uppercase;
  text-decoration: none;
  font-weight: bold;
  font-size: 1rem;
  font-weight: bold;
  color:  ${props => props.variation === 'gold' ? '#232323' : '#fff'};

  background: ${props => props.variation === 'transparent' ? 'rgba(0, 0, 0, 0.3)' : props.variation === 'gold' ? '#F2C94C' : '#000'};
  box-sizing: border-box;
  border: 2px solid ${props => props.variation === 'gold' ? '#F2C94C' : '#fff'};
  user-select: none;

  transition: color 150ms ease-in-out, background-color 150ms ease-in-out;

  &:hover {
    color: #000;
    background: #fff;
  }

  &:focus
  {
    outline: none;
  }
`

export const StyledButtonAnchor = styled.a`
  height: 3rem;
  width: 100%;
  max-width: ${props => props.isFullWidth === 'true' ? '100%' : '280px'};

  vertical-align: top;
  font-family: 'Source Sans Pro';
  line-height: 1.5rem;

  padding-top: 0.4375rem;
  padding-bottom: 0.5rem;
  padding-left: 32px;
  padding-right: 32px;
  display: inline-block;

  text-align: center;
  text-transform: uppercase;
  text-decoration: none;
  font-weight: bold;
  font-size: 1rem;
  font-weight: bold;
  color:  ${props => props.variation === 'gold' ? '#232323' : '#fff'};

  background: ${props => props.variation === 'transparent' ? 'rgba(0, 0, 0, 0.3)' : props.variation === 'gold' ? '#F2C94C' : '#000'};
  box-sizing: border-box;
  border: 2px solid ${props => props.variation === 'gold' ? '#F2C94C' : '#fff'};
  user-select: none;

  transition: color 150ms ease-in-out, background-color 150ms ease-in-out;

  &:hover {
    color: #000;
    background: #fff;
  }

  &:focus
  {
    outline: none;
  }
`

const StyledAnchor = styled.a`
  height: 3rem;
  width: 100%;
  max-width: ${props => props.isFullWidth === 'true' ? '100%' : '280px'};


  font-family: 'Source Sans Pro';
  line-height: 1.5rem;

  padding-top: 0.4375rem;
  padding-bottom: 0.5rem;
  padding-left: 32px;
  padding-right: 32px;

  text-align: center;
  text-transform: uppercase;
  text-decoration: none;
  font-weight: bold;
  font-size: 1rem;
  font-weight: bold;
  color:  ${props => props.variation === 'gold' ? '#232323' : '#fff'};

  background: ${props => props.variation === 'transparent' ? 'rgba(0, 0, 0, 0.3)' : props.variation === 'gold' ? '#F2C94C' : '#000'};
  box-sizing: border-box;
  border: 2px solid ${props => props.variation === 'gold' ? '#F2C94C' : '#fff'};
  user-select: none;

  transition: color 150ms ease-in-out, background-color 150ms ease-in-out;

  &:hover {
    color: #000;
    background: #fff;
  }

  &:focus
  {
    outline: none;
  }
`


export const TextLink = styled(Link)`
  text-decoration: none;
  border-bottom: 1px solid;
  border-color: inherit;
  color: inherit;
  padding-bottom: 3px;
  ${props => props.variation === 'bold' && `
    font-weight: bold;
  ` }
  ${props => props.variation === 'gray' && `
    color: #C4C4C4;
  ` }
  ${props => props.variation === 'darkgray' && `
    color: #697376;
  ` }
`

const ButtonGroup = (props) => (
  <Wrap margin={props.margin}>
    {props.links.map(link => {
      if (link.url.substr(0, 4) === 'http' || link.url.substr(0,4) === 'https') {
        return <StyledAnchor href={link.url} isFullWidth={props.isFullWidth} variation={props.variation}>{link.title}</StyledAnchor>
      }
      else {
        return <StyledLink to={link.url} isFullWidth={props.isFullWidth} variation={props.variation}>{link.title}</StyledLink>
      }
    })}
  </Wrap>
)

export default ButtonGroup



// WEBPACK FOOTER //
// ./src/components/Home/ButtonGroup.js